import React, { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { PageContext } from "../../context/PageContext";
import LoadingPage from "../../components/LoadingPage";
import { useReadingEmail } from "../../hooks/useReadingEmail";
import { useContacts } from "../../hooks/useContacts";
import { ContactType } from "../../models/ContactModels";
import { ContactNotFound } from "./ContactNotFound";
import { MultiContactsMatched } from "./MultiContactsMatched";
import { ContactList } from "./ContactList";

const Contacts = () => {
  const { emailAddress } = useReadingEmail();
  const { contacts, ...contactsResponse } = useContacts(emailAddress);
  const suppliers = contacts?.filter(
    ({ type }) => type === ContactType.Supplier || type === ContactType.SupplierCustomer
  );
  const customers = contacts?.filter(
    ({ type }) => type === ContactType.Customer || type === ContactType.SupplierCustomer
  );

  const { setNewTitle } = useContext(PageContext);

  useEffect(() => {
    setNewTitle("Contacts");
  }, [suppliers, setNewTitle]);

  if (contactsResponse.isLoading || contactsResponse.isError) {
    return <LoadingPage />;
  }

  if (!suppliers?.length && !customers?.length) {
    return <ContactNotFound email={emailAddress ?? ""} />;
  }

  if (suppliers?.length && customers?.length) {
    return <MultiContactsMatched email={emailAddress ?? ""} suppliers={suppliers} customers={customers} />;
  }

  if (suppliers?.length) {
    return suppliers.length === 1 ? (
      <Navigate to={`/payables/${suppliers[0].id}?hideBackButton=true`} />
    ) : (
      <ContactList contacts={suppliers} type="payables" />
    );
  }

  if (customers?.length) {
    return customers.length === 1 ? (
      <Navigate to={`/receivables/${customers[0].id}?hideBackButton=true`} />
    ) : (
      <ContactList contacts={customers} type="receivables" />
    );
  }

  return <Navigate to="/" />;
};

export default Contacts;
